import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';
import { Link as RouterLink } from 'react-router-dom';

import { mq } from './styles_root';

export const Heading = styled.h1(
  ({ bold }) => css`
    text-align: center;
    font-size: 24px;
    font-weight: ${bold ? 'bold' : 'initial'};
    padding-bottom: ${bold ? '16px' : '0px'};
  `
);

export const Subheading = styled.p`
  font-size: 14px;
`;

export const Form = styled.form``;

export const FormContainer = styled.div`
  background: white;

  margin: 0 auto;
  padding: 30px 15px 50px 15px;

  ${mq[1]} {
    max-width: 480px;
    margin: 40px auto;
    margin-bottom: 0px;
    padding: 50px;
    padding-top: 32px;
  }
`;

export const Label = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
`;

export const InputSection = styled.div`
  position: relative;
  margin-bottom: 25px;
`;

export const LoginOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Link = styled(RouterLink)`
  display: block;
  color: ${(props) => props.theme.linkColor};
  text-decoration: underline;
  cursor: pointer;

  margin: ${(props) => (props.margin ? props.margin : '0px')};
  text-align: ${(props) => (props.center ? 'center' : 'unset')};
`;

export const CenteredLink = styled(Link)`
  width: 100%;
  text-align: center;
`;

export const InlineLink = styled(Link)`
  display: inline-block;
  text-decoration: none;
`;

export const InlineAnchor = styled.a(
  ({ theme, padding, underline }) => css`
    color: ${theme.linkColor};
    padding: ${padding || '0px'};
    text-decoration: ${underline ? 'underline' : 'none'};
  `
);

export const Input = styled.input`
  width: 100%;
  font-size: 14px;
  padding: 14px 10px;

  box-sizing: border-box;
  border: 1px solid
    ${(props) =>
      props.disabled
        ? Theme.colors.lightBackground
        : Theme.colors.inputs.border};
  border-radius: 0px;

  background: ${(props) =>
    props.disabled ? Theme.colors.lightBackground : 'white'};

  ::placeholder {
    color: ${Theme.colors.lightText};
  }
`;

export const Error = styled.div`
  padding: 6px 10px;
  color: ${Theme.colors.red};
`;

export const Requirement = styled.div`
  color: ${Theme.colors.lightText};
  margin-bottom: 50px;
`;
